import { useNavigate } from "react-router-dom";
import MaterialTable from "../components/Catalogue/MaterialTable";
import backLogo from "../assets/back-logo.png";
import { useEffect, useState } from "react";
import { LoaderIcon } from "react-hot-toast";
import { Info } from "@mui/icons-material";

function ProductsTable({ isVendorName }) {
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const qpartname = query.get("qpartname");
  const [isLoading, setIsLoading] = useState(qpartname ? false : true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1800); // 2 seconds delay

    return () => clearTimeout(timer); // Cleanup timer
  }, []);

  return (
    <div>
      <div className="flex gap-1 items-center justify-between py-3 lg:py-10 px-2 bg-white lg:static sticky top-0 left-0 z-[100] lg:shadow-none shadow-md">
        {/* <img
          src={backLogo}
          width={25}
          height={10}
          onClick={() => navigate(-1)}
          className="lg:hidden"
        /> */}

        <div
          className="flex items-center cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <img
            src={backLogo}
            width={25}
            height={10}
            onClick={() => navigate(-1)}
            className="lg:hidden"
          />
          <div>
            <h1 className="text-xl md:text-2xl">Κατάλογος</h1>
            <div className="tooltip-wrapper hidden sm:inline-block">
              <Info className="info-icon" />
              <div className="tooltip-content">
                <p>Ο κατάλογος ανανεώνεται κάθε 10 λεπτά.</p>
                <p>
                  Back to Stock: Η πληροφορία είναι άμεση και εμφανίζεται τη στιγμή που ζητείται.
                </p>
                <p>
                  Back to Stock (Pharmacy): Η πληροφορία συγχρονίζεται μία φορά ημερησίως, στις 16:20.
                </p>
                <p>
                  Η ημερομηνία λήξης είναι πάντα η πιο κοντινή. Επιλέξτε  για να δείτε όλες τις ημερομηνίες λήξης.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <button className="basket-mobile md:hidden" onClick={handleCartClick}>
          <span className="icon-mobile">
            {totalItems ? JSON.parse(totalItems).length : 0}
          </span>
        </button> */}
      </div>
      {isLoading ? (
        <div className="flex justify-center py-10 w-full">
          <LoaderIcon />
        </div>
      ) : (
        <MaterialTable isVendorName={isVendorName} />
      )}
    </div>
  );
}

export default ProductsTable;
